import { usePartnerInfo } from "src/Utils/Hooks/usePartnerInfoContext";
import AuraAppLicenses from "./AuraAppLicenses/AuraAppLicenses";
import AuraSoftwareSuiteLicenses from "./AuraSoftwareSuitesLicenses/AuraSoftwareSuitesLicenses";
import { IAuraSoftwareSuiteLicensesInfo, IClinic, IUserLicencesInfo } from "src/Utils/Hooks/useGetDistributorInfo/useGetDistributorInfo";
import SearchBar from "src/SharedComponents/SearchBar/SearchBar";
import { useMemo, useState } from "react";
import { useSearch } from "src/Utils/Hooks/SearchData/useSearch";

const Licenses = () => {
    const { distributorDetails } = usePartnerInfo();
    const [searchText, setSearchText] = useState<string>('');
    const clinicDetails: IClinic[] | undefined = distributorDetails?.clinics;

    const searchKeys1 = useMemo<(keyof IUserLicencesInfo)[]>(() => ['entitlementId', 'clinicName'], []);
    const searchKeys2 = useMemo<(keyof IAuraSoftwareSuiteLicensesInfo)[]>(() => ['entitlementId', 'clinicName'], []);

    const usersAndStorageLicensesInfo = useMemo(() => distributorDetails?.licenses?.userAndStorageLicenseInfo || [], [distributorDetails]);
    const userLicensesInfo = useMemo(() => distributorDetails?.licenses?.userLicencesInfo || [], [distributorDetails]);

    const isSuiteLicense = (licenseType: string) => licenseType.toLowerCase().includes("suite");

    const otherLicensesInfo = useMemo(() => {
        return usersAndStorageLicensesInfo.filter(
            (license) => !isSuiteLicense(license.licenseType)
        );
    }, [usersAndStorageLicensesInfo]);

    const suiteLicensesInfo = useMemo(() => {
        return usersAndStorageLicensesInfo.filter(
            (license) => isSuiteLicense(license.licenseType)
        );
    }, [usersAndStorageLicensesInfo]);

    const nonSuiteLicensesInfo = useMemo(() => {
        return [
            ...userLicensesInfo,
            ...otherLicensesInfo
        ];
    }, [userLicensesInfo, otherLicensesInfo]);

    const filteredUserLicenses = useSearch(nonSuiteLicensesInfo, searchText, searchKeys1);
    const filteredAuraSuiteLicenses = useSearch(suiteLicensesInfo, searchText, searchKeys2);

    return(
        <>
            <div className="pb-2">
                <div className="row m-2" style={{width:"97%"}}>
                    <SearchBar onChange={(text:string) => {setSearchText(text) }} />
                </div>
            </div>
            {distributorDetails &&
                <>
                    {
                        filteredAuraSuiteLicenses && filteredAuraSuiteLicenses.length > 0 ?
                        <div>
                            <AuraSoftwareSuiteLicenses auraSoftwareSuiteLicenses={filteredAuraSuiteLicenses} clinics={clinicDetails} distributorId={distributorDetails.distributorId}/>
                        </div> : <></>
                    }
                    {
                        filteredUserLicenses && filteredUserLicenses.length > 0 ? 
                        <div className="pt-3">
                            <AuraAppLicenses auraAppLicenses={filteredUserLicenses} clinics={clinicDetails} distributorId={distributorDetails.distributorId} otherLicenses={otherLicensesInfo}/>
                        </div> : <></>
                    }
                </>
            }
        </>
    );
}

export default Licenses;